import { QuestionPlanIsNoAddressNeeded as Question } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-no-address-needed";

import { useDayTripPlanIsNoAddressNeeded } from "./hooks";

export const QuestionDyTripPlanIsNoAddressNeeded = () => {
	const { isNoAddressNeeded, onSetIsNoAddressNeeded } = useDayTripPlanIsNoAddressNeeded();

	return <Question isNoAddressNeeded={isNoAddressNeeded} onSetIsNoAddressNeeded={onSetIsNoAddressNeeded} />;
};

QuestionDyTripPlanIsNoAddressNeeded.displayName = "QuestionDyTripPlanIsNoAddressNeeded";
